import {
  EmojiRepository,
  UploadingEmojiProvider
} from '@atlaskit/emoji/resource';
import {
  EmojiDescription,
  EmojiId,
  OptionalEmojiDescriptionWithVariations
} from '@atlaskit/emoji/types';
import { SandboxNonUploadingEmojiResource } from './sandbox-non-uploading-emoji-resource';
import { SandboxEmojiResourceConfig, UploadDetail } from './types';

export class SandboxEmojiResource
  extends SandboxNonUploadingEmojiResource
  implements UploadingEmojiProvider
{
  private uploads: UploadDetail[] = [];

  constructor(
    emojiService: EmojiRepository,
    config?: SandboxEmojiResourceConfig
  ) {
    super(emojiService, config);
  }

  async getMediaEmojiDescriptionURLWithInlineToken(
    emoji: EmojiDescription
  ): Promise<EmojiDescription> {
    if (this.promiseBuilder) {
      return this.promiseBuilder(
        emoji,
        'getMediaEmojiDescriptionURLWithInlineToken'
      );
    }
    return emoji;
  }

  async fetchEmojiProvider(): Promise<EmojiRepository | undefined> {
    return Promise.resolve(this.emojiRepository);
  }

  public async fetchByEmojiId(
    emojiId: EmojiId
  ): Promise<OptionalEmojiDescriptionWithVariations> {
    return this.findByEmojiId(emojiId);
  }

  public getOptimisticImageURL() {
    return undefined;
  }

  isUploadSupported(): Promise<boolean> {
    return this.promiseBuilder(false, 'isUploadSupported');
  }

  uploadCustomEmoji() {
    return this.promiseBuilder(null, 'uploadCustomEmoji');
  }

  getUploads(): UploadDetail[] {
    return this.uploads;
  }

  prepareForUpload() {
    return Promise.resolve();
  }

  // Make public for testing
  notifyNotReady() {
    super.notifyNotReady();
  }

  loadMediaEmoji(emoji: EmojiDescription) {
    if (this.promiseBuilder) {
      return this.promiseBuilder(emoji, 'loadMediaEmoji');
    }
    return emoji;
  }
}
